import { render, staticRenderFns } from "./BottomAppBar.vue?vue&type=template&id=1287f147&scoped=true&"
import script from "./BottomAppBar.vue?vue&type=script&lang=js&"
export * from "./BottomAppBar.vue?vue&type=script&lang=js&"
import style0 from "./BottomAppBar.vue?vue&type=style&index=0&id=1287f147&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1287f147",
  null
  
)

export default component.exports